module.exports = __webpack_public_path__ + "img/staff-photo-3.2e7dbe6.png";